import { createAsyncThunk } from "@reduxjs/toolkit";

import { getContractStats as getContractStatsApi } from "../../helpers/fakebackend_helper";

// The backend wraps every success response as {"data": ...} (see
// core/responses.success_response) — unwrap that one extra level here so
// the slice stores the clean {all, overdue, due_soon, unscheduled, settled,
// years} object directly, not a {data: {...}} wrapper.
export const getContractStats = createAsyncThunk(
  "contractStats/getContractStats",
  async (queryParams) => {
    const response = await getContractStatsApi(queryParams);
    return response.data;
  }
);
